module.exports = __webpack_public_path__ + "static/challenge-ampol-8aaea44d5f12182aefe106ced6c5b436.png";